import { render, staticRenderFns } from "./EndPage.vue?vue&type=template&id=00920645&"
import script from "./EndPage.vue?vue&type=script&lang=js&"
export * from "./EndPage.vue?vue&type=script&lang=js&"
import style0 from "./EndPage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports